var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { signatureVerify, cryptoWaitReady, decodeAddress, } from '@polkadot/util-crypto';
export class PolkaJsVerifier {
    verify(alg, message, signature, address) {
        return __awaiter(this, void 0, void 0, function* () {
            yield cryptoWaitReady();
            let publicKey = decodeAddress(address);
            let { isValid, crypto } = signatureVerify(message, signature, publicKey);
            if (!isValid) {
                return false;
            }
            if (crypto != alg) {
                throw new Error(`signing algorithm does not match. expected alg:${alg} != signed alg:${crypto}`);
            }
            return true;
        });
    }
}
